import { Configuration as DocumentsConfig, DocumentsApi } from "api/documents";
import { createApiConfig } from "./adapters";

export const documentsAPI = new DocumentsApi(createApiConfig(DocumentsConfig));
